import React, { Component } from 'react'
import { FileUploader, Button, Form } from 'devextreme-react'
import DevextremeTab from 'components/inheritComponent/devextremeTab'
import { Popup } from 'devextreme-react/popup'
import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import Excel from 'exceljs/dist/exceljs'
import saveAs from 'file-saver'
import XLSX from 'xlsx'
import { alert } from 'devextreme/ui/dialog'
import httpRequest from 'plugin/httprequest'
import { showLoading } from 'redux/actions/loading'
import { confirmExit, confirmSubmit } from 'plugin/helper'
import { months, participants } from 'dataSource/lookup'
import { formatUploadFileData } from 'plugin/helper'

class ModalUploadiuran extends Component {
  constructor(props) {
    super(props)
    this.state = {
      popupVisible: false,
      uploadedData: [],
      selectedTabIndex: 0,
      dataParent: {
        participantCode: this.props.store.getState().sessionUser.participantId,
        participantName: this.props.store.getState().sessionUser.participantId,
      },
      dataMaster: {
        validData: [],
        invalidData: [],
      },
      DataDocument: {},
    }

    this.isNew = false

    this.dataGridResultValid = React.createRef()
    this.dataGridResultInvalid = React.createRef()
    this.fileUploderRef = React.createRef()
    this.formRef = React.createRef()

    this.TabDataSource = [
      {
        id: 0,
        text: 'Data Sesuai',
      },
      {
        id: 1,
        text: 'Data Tidak Sesuai',
      },
    ]
    this.PopupToolbarItem = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Simpan',
          elementAttr: { class: 'bg-button-popup-save-dapen-default' },
          onClick: async () => {
            let getData = this.dataGridResultValid.current.getDataSource()
            if (getData.length !== 0) {
              let result = await confirmSubmit()
              if (result) {
                var formValidation = this.validate()
                if (formValidation) {
                  await this.saveData()
                }
              }
            } else {
              await alert('Silahkan upload terlebh dahulu', 'Informasi')
            }
          },
        },
        toolbar: 'bottom',
      },
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Batal',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: this.hide.bind(this),
        },
        toolbar: 'bottom',
      },
    ]
    this.columns = [
      {
        dataField: 'id',
        caption: 'No.',
      },
      {
        dataField: 'productCode',
        caption: 'Kode Produk',
      },
      {
        dataField: 'tahun',
        caption: 'Tahun',
        alignment: 'right',
      },
      {
        dataField: 'bulan',
        caption: 'Bulan',
        lookup: {
          dataSource: months(this.props.store),
          valueExpr: 'id',
          displayExpr: 'value',
        },
      },
      {
        dataField: 'nik',
        caption: 'NIK',
      },
      {
        dataField: 'fullName',
        caption: 'Nama Lengkap',
      },
      {
        dataField: 'iuranNormalPeserta',
        caption: 'Iuran Normal Peserta',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'iuranNormalPK',
        caption: 'Iuran Normal PK',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'iuranSukarela',
        caption: 'Iuran Sukarela',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
    ]
    this.colmnsInvalid = [
      ...this.columns,
      {
        caption: 'Catatan',
        dataField: 'message',
      },
    ]
    this.formItems = [
      {
        itemType: 'group',
        caption: 'Periode Iuran',
        cssClass: 'group-radius',
        items: [
          {
            dataField: 'tahun',
            label: {
              text: 'Tahun',
            },
            editorType: 'dxNumberBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-dapen-default' },
              min: new Date().getFullYear(),
            },
            validationRules: [
              {
                type: 'custom',
                validationCallback: (e) => {
                  return e.value >= new Date().getFullYear()
                },
                message: `Tahun tidak boleh kurang dari ${new Date().getFullYear()}!`,
              },
              {
                type: 'required',
                message: 'Tahun harus diisi!',
              },
            ],
          },
          {
            dataField: 'bulan',
            label: {
              text: 'Bulan',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-dapen-default' },
              dataSource: months(),
              valueExpr: 'id',
              displayExpr: 'value',
              searchEnabled: true,
              deferRendering: false,
            },
            validationRules: [
              {
                type: 'required',
                message: 'Mohon memilih bulan.',
              },
            ],
          },
        ],
      },
      {
        itemType: 'group',
        caption: 'Informasi Participant',
        cssClass: 'group-radius',
        items: [
          {
            dataField: 'participantCode',
            label: {
              text: 'Kode Participant',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              dataSource: participants(this.props.store),
              valueExpr: 'id',
              displayExpr: 'participantCode',
              placeholder: 'Kode Participant',
              deferRendering: false,
              readOnly: true,
            },
          },
          {
            dataField: 'participantName',
            label: {
              text: 'Nama Participant',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              dataSource: participants(this.props.store),
              valueExpr: 'id',
              displayExpr: 'participantName',
              placeholder: 'Kode Participant',
              deferRendering: false,
              readOnly: true,
            },
          },
        ],
      },
    ]

    this.successData = []
    this.errorData = []
  }

  show = () => {
    this.props.store.dispatch(showLoading(true))
    this.setState({
      popupVisible: true,
    })
    this.props.store.dispatch(showLoading(false))
  }

  hide = async (e) => {
    let result
    if (this.state.popupVisible === true && !this.isNew) {
      if (typeof e.cancel === 'boolean') {
        e.cancel = true
      }
      result = await confirmExit()
    } else {
      result = true
    }

    if (result) {
      if (!this.isNew) {
        if (typeof e.cancel === 'boolean') {
          e.cancel = false
        }
      }

      this.setState({
        popupVisible: false,
        formData: {},
        dataMaster: {
          validData: [],
          invalidData: [],
        },
      })
    }
  }

  validate = () => {
    var formValidation = this.formRef.current.instance.validate()
    return formValidation.isValid
  }

  onTabSelectionChanged = (args) => {
    this.props.store.dispatch(showLoading(true))
    this.setState({ selectedTabIndex: args.value })
    this.props.store.dispatch(showLoading(false))
  }

  onUploadStarted = async (e) => {
    this.props.store.dispatch(showLoading(true))
    this.successData = []
    this.errorData = []
    this.getPropertiesExcel(e)
    for (let i = 0; i < e.value.length; i++) {
      const file = e.value[i]
      const fileType = file.name.split('.').pop().toLowerCase()
      const reader = new FileReader()

      reader.onload = async (event) => {
        const dataArrayBuffer = new Uint8Array(event.target.result)
        let data = []

        if (fileType === 'xls' || fileType === 'xlsx') {
          data = this.parseExcelData(dataArrayBuffer)
        } else {
          this.props.store.dispatch(showLoading(false))
          alert('Format file tidak sesuai!', 'Informasi!')
          return
        }
        data = this.filterEmptyRows(data)
        if (data.length > 0) {
          this.processData(data)
        } else {
          this.props.store.dispatch(showLoading(false))
          alert('File yang di upload tidak memiliki data!', 'Informasi!')
          return
        }

        this.props.store.dispatch(showLoading(false))

        console.log(this.successData)

        if (this.successData.length > 0) {
          await this.processSuccessData()
        }

        if (this.errorData.length > 0) {
          this.downloadExcel()
        }
        this.showAlert()
        this.props.store.dispatch(showLoading(false))
      }

      reader.readAsArrayBuffer(file)
    }
  }

  getPropertiesExcel(e) {
    const fieldName = e.component._options._optionManager._options.name
    const DataDocument = { ...this.state.DataDocument }

    e.value.forEach((file) => {
      const fr = new FileReader()
      fr.onload = (efr) => {
        const formattedFileData = formatUploadFileData(efr.target.result)

        DataDocument[`${fieldName}Name`] = file.name
        DataDocument[`${fieldName}File`] = formattedFileData.base64data
        DataDocument[`${fieldName}FileContentType`] = formattedFileData.mime

        this.setState({
          DataDocument: DataDocument,
        })
      }

      fr.readAsDataURL(file)
    })
  }

  parseExcelData = (dataArrayBuffer) => {
    const workbook = XLSX.read(dataArrayBuffer, { type: 'array' })
    const sheet = workbook.Sheets[workbook.SheetNames[0]]
    const dataJSON = XLSX.utils.sheet_to_json(sheet)
    return dataJSON.map((value) => Object.values(value))
  }

  filterEmptyRows = (data) => {
    return data.filter((row) => row.every((cell) => cell !== ''))
  }

  processData = async (data) => {
    const validateField = (value, regex, errorMessage) => {
      if (!regex.test(value)) {
        return errorMessage
      }
      return null
    }

    for (const row of data) {
      let errorMessage = []

      if (Array.isArray(row)) {
        errorMessage.push(
          validateField(
            row[0],
            /^[a-zA-Z0-9-]+$/,
            'Format Kode Produk Dana Pensiun tidak valid!'
          ),
          validateField(
            row[1],
            /^\d{4}$/,
            'Format tahun tidak valid! Harus berupa 4 digit angka.'
          ),
          validateField(
            row[2],
            /^(0?[1-9]|1[0-2])$/,
            'Format Bulan tidak valid! Harus berupa angka dari 1 hingga 12.'
          ),
          validateField(
            row[3],
            /^[a-zA-Z0-9-]+$/,
            'Format NIK tidak valid! Hanya boleh berisi huruf, angka, dan tanda minus (-).'
          ),
          validateField(
            row[4],
            /^[a-zA-Z\s]+$/,
            'Format Nama Lengkap tidak valid! Hanya boleh berisi huruf dan spasi.'
          ),
          validateField(
            row[5],
            /^\d+(\.\d{1,2})?$/,
            'Format nilai Iuran Normal Peserta tidak valid! Harus berupa angka atau format uang (contoh: 458765.45).'
          ),
          validateField(
            row[6],
            /^\d+(\.\d{1,2})?$/,
            'Format nilai Iuran Normal PK tidak valid! Harus berupa angka atau format uang (contoh: 1256874.76).'
          ),
          validateField(
            row[7],
            /^\d+(\.\d{1,2})?$/,
            'Format nilai Iuran Sukarela tidak valid! Harus berupa angka atau format uang (contoh: 200000).'
          )
        )

        errorMessage = errorMessage.filter(Boolean)
        console.log(errorMessage)

        if (errorMessage.length > 0) {
          this.errorData.push({
            productCode: row[0],
            tahun: row[1],
            bulan: row[2],
            nik: row[3],
            fullName: row[4],
            iuranNormalPeserta: row[5],
            iuranNormalPK: row[6],
            iuranSukarela: row[7],
            message: errorMessage.join(' '),
          })
        } else {
          this.successData.push({
            productCode: row[0],
            tahun: row[1],
            bulan: row[2],
            nik: row[3],
            fullName: row[4],
            iuranNormalPeserta: row[5],
            iuranNormalPK: row[6],
            iuranSukarela: row[7],
          })
        }
      }
    }
  }

  processSuccessData = async () => {
    const validData = []
    const invalidData = []

    for (const data of this.successData) {
      let messages = []

      try {
        const checkProductCode = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `products?productCode.equals=${data.productCode}`,
          'GET'
        )

        if (checkProductCode.length === 0) {
          messages.push('Product Code tidak sesuai')
        }

        const checkNikAndFullName = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `pesertas/getByNik/${data.nik}`,
          'GET'
        )

        if (!checkNikAndFullName) {
          messages.push('NIK tidak ditemukan')
        } else if (checkNikAndFullName.fullName !== data.fullName) {
          messages.push('Nama tidak sesuai dengan data yang ada di NIK')
        }

        if (messages.length > 0) {
          data.message = messages.join(', ')
          invalidData.push(data)
        } else {
          validData.push(data)
        }
      } catch (error) {
        console.error(error)
        this.props.store.dispatch(showLoading(false))
        alert('Informasi!', 'Terjadi Kesalahan!')
        return
      }
    }

    const validDataWithIds = validData.map((item, index) => ({
      id: index + 1,
      ...item,
    }))
    const invalidDataWithIds = invalidData.map((item, index) => ({
      id: index + 1,
      ...item,
    }))

    this.setState((prevState) => ({
      dataMaster: {
        validData: [...prevState.dataMaster.validData, ...validDataWithIds],
        invalidData: [
          ...prevState.dataMaster.invalidData,
          ...invalidDataWithIds,
        ],
      },
    }))
  }

  saveData = async () => {
    this.isNew = true
    this.props.store.dispatch(showLoading(true))
    const data = this.state.dataMaster.validData
    const documentExcel = this.state.DataDocument
    const dataParent = this.state.dataParent
    try {
      const detils = data.map((item) => ({
        fullName: item.fullName,
        iuranLain: item.iuranSukarela,
        iuranPeserta: item.iuranNormalPeserta,
        iuranPk: item.iuranNormalPK,
        nik: item.nik,
        productCode: item.productCode,
      }))
      const payload = {
        bulan: dataParent.bulan,
        tahun: dataParent.tahun,
        detils: detils,
        file: documentExcel.uploadStatusInvestasiFile,
        fileContentType: documentExcel.uploadStatusInvestasiFileContentType,
        fileName: documentExcel.uploadStatusInvestasiName,
        participantId: this.props.store.getState().sessionUser.participantId,
      }
      await httpRequest(
        process.env.REACT_APP_BACKEND_CORE,
        this.props.store,
        'participant-iuran-uploads/upload',
        'POST',
        { values: payload }
      )
      this.props.store.dispatch(showLoading(false))
      let confirm = await alert('Data berhasil disimpan', 'Success!')
      if (confirm) {
        this.hide()
        this.rollbackGrid()
        this.props.forceRefresh()
      }
    } catch (error) {
      console.error('Error uploading data:', error)
      this.props.store.dispatch(showLoading(false))
      let confirm = alert('Data gagal disimpan', 'Error!')
      if (confirm) {
        this.props.forceRefresh()
      }
    }
  }

  rollbackGrid = () => {
    this.setState({
      dataMaster: {
        validData: [],
        invalidData: [],
      },
    })
  }

  showAlert = () => {
    const alertMessage = `<span style="font-size:14px;">Success data uploaded: ${this.successData.length}</span><br/><span style="font-size:14px;">Failed Data uploaded: ${this.errorData.length}</span><br/><br/>`
    alert(alertMessage, 'Hasil Upload !')
  }

  downloadExcelTemplate = async () => {
    const workbook = new Excel.Workbook()
    const worksheet = workbook.addWorksheet('Template')
    worksheet.columns = [
      { header: 'Kode Produk Dana Pensiun', key: 'productCode', width: 25 },
      { header: 'Tahun', key: 'tahun', width: 10 },
      { header: 'Bulan', key: 'bulan', width: 10 },
      { header: 'nik', key: 'nik', width: 10 },
      { header: 'Nama Lengkap', key: 'fullName', width: 25 },
      { header: 'Iuran Normal Peserta', key: 'iuranNormalPeserta', width: 20 },
      { header: 'Iuran Normal PK', key: 'iuranNormalPK', width: 20 },
      { header: 'Iuran Sukarela', key: 'iuranSukarela', width: 20 },
    ]

    worksheet.addRow({
      productCode: '',
      tahun: '',
      bulan: '',
      nik: '',
      fullName: '',
      iuranNormalPeserta: '',
      iuranNormalPK: '',
      iuranSukarela: '',
    })
    const buffer = await workbook.xlsx.writeBuffer()
    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      'Template Upload.xlsx'
    )
  }

  downloadExcel = () => {
    const wb = XLSX.utils.book_new()
    const wsSuccess = XLSX.utils.json_to_sheet(this.successData, {
      header: [
        'productCode',
        'tahun',
        'bulan',
        'nik',
        'fullName',
        'iuranNormalPeserta',
        'iuranNormalPK',
        'iuranSukarela',
      ],
    })
    XLSX.utils.book_append_sheet(wb, wsSuccess, 'Success')
    const wsError = XLSX.utils.json_to_sheet(this.errorData, {
      header: [
        'productCode',
        'tahun',
        'bulan',
        'nik',
        'fullName',
        'iuranNormalPeserta',
        'iuranNormalPK',
        'iuranSukarela',
        'message',
      ],
    })
    XLSX.utils.book_append_sheet(wb, wsError, 'Error')

    const now = new Date()
    const day = String(now.getDate()).padStart(2, '0')
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const year = now.getFullYear()
    const seconds = String(now.getSeconds()).padStart(2, '0')
    const formattedDateTime = `${day}${month}${year
      .toString()
      .slice(-2)}${seconds}`
    const fileName = `DS-upload-status-invest-${formattedDateTime}.xlsx`
    XLSX.writeFile(wb, fileName)
  }

  dataGridValid = () => {
    return (
      <DevExpressDataGrid
        ref={this.dataGridResultValid}
        loadAPI=""
        insertAPI=""
        updateAPI=""
        deleteAPI=""
        backendserver={process.env.REACT_APP_BACKEND_CORE}
        useArraySource={true}
        ArraySourceData={this.state.dataMaster.validData}
        allowAdding={false}
        allowDeleting={false}
        allowUpdating={false}
        exportExcel={false}
        exportFileName={''}
        allowExportSelectedData={false}
        showBorders={true}
        paging={false}
        defaultPageSize={10}
        popupTitle={'Data Sukses'}
        popupWidth={500}
        popupHeight={300}
        popupFormLabelLocation="left"
        popupFormMinColWidth={300}
        popupFormColCount={3}
        ColumnChooser={false}
        ColumnFixing={true}
        FilterRow={false}
        ColumnConfiguration={this.columns}
        height={'calc(50vh - 150px)'}
        keyField={'id'}
        store={this.props.store}
      />
    )
  }

  dataGridInvalid = () => {
    return (
      <DevExpressDataGrid
        ref={this.dataGridResultInvalid}
        loadAPI=""
        insertAPI=""
        updateAPI=""
        deleteAPI=""
        backendserver={process.env.REACT_APP_BACKEND_CORE}
        useArraySource={true}
        ArraySourceData={this.state.dataMaster.invalidData}
        allowAdding={false}
        allowDeleting={false}
        allowUpdating={false}
        exportExcel={false}
        exportFileName={''}
        allowExportSelectedData={false}
        showBorders={true}
        paging={false}
        defaultPageSize={10}
        popupTitle={'Data Sukses'}
        popupWidth={500}
        popupHeight={300}
        popupFormLabelLocation="left"
        popupFormMinColWidth={300}
        popupFormColCount={3}
        ColumnChooser={false}
        ColumnFixing={true}
        FilterRow={false}
        ColumnConfiguration={this.colmnsInvalid}
        height={'calc(50vh - 150px)'}
        keyField={'id'}
        store={this.props.store}
      />
    )
  }

  render() {
    const { selectedTabIndex } = this.state
    let dataGridValid = this.state.popupVisible && this.dataGridValid()
    let dataGridInvalid = this.state.popupVisible && this.dataGridInvalid()
    return (
      <React.Fragment>
        <Popup
          className={'popup'}
          visible={this.state.popupVisible}
          onHiding={this.hide}
          dragEnabled={true}
          showTitle={true}
          title={'Upload Data Iuran'}
          width={'70vw'}
          height={'auto'}
          toolbarItems={this.PopupToolbarItem}
        >
          <Form
            ref={this.formRef}
            colCount={2}
            id={'formPotongan'}
            formData={this.state.dataParent}
            items={this.formItems}
            labelLocation="left"
          />
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex flex-row">
              <div style={{ width: '350px' }}>
                <FileUploader
                  accept={'.xls,.xlsx,.csv'}
                  uploadMode={'useForm'}
                  onValueChanged={this.onUploadStarted.bind(this)}
                  labelText="Upload File Disini"
                  showFileList={false}
                  name={'uploadStatusInvestasi'}
                  value={this.state.uploadedData}
                  ref={this.fileUploderRef}
                />
              </div>
            </div>
            <div>
              <Button
                width={250}
                elementAttr={{ class: 'bg-button-export-dapen-default' }}
                text={'Download Template'}
                type={'success'}
                stylingMode={'contained'}
                onClick={this.downloadExcelTemplate.bind(this)}
                className={'mx-2'}
                visible={true}
              />
            </div>
          </div>
          <DevextremeTab
            dataSource={this.TabDataSource}
            onOptionChanged={this.onTabSelectionChanged}
          />
          <div
            id="resultTableUpload-0"
            className={`mt-2 col-md-12 text-center ${
              selectedTabIndex !== 0 ? 'd-none' : ''
            }`}
          >
            {dataGridValid}
          </div>
          <div
            id="resultTableUpload-1"
            className={`mt-2 col-md-12 text-center ${
              selectedTabIndex !== 1 ? 'd-none' : ''
            }`}
          >
            {dataGridInvalid}
          </div>
        </Popup>
      </React.Fragment>
    )
  }
}
export default ModalUploadiuran
